import { useState, useEffect } from "react";

const isLandscapeShape = () => {
  const { innerWidth: width, innerHeight: height } = window;
  if (width <= height) return false;

  const isTouchPrimary = window.matchMedia("(pointer: coarse)").matches;
  const shortSideIsPhoneSized = height <= 560;

  return isTouchPrimary || shortSideIsPhoneSized;
};

const useScreenOrientation = () => {
  const [height, setHeight] = useState<number>(typeof window !== "undefined" ? window.innerHeight : 0);
  const [horizontal, setHorizontal] = useState<boolean>(
    typeof window !== "undefined" ? isLandscapeShape() : false,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    let resizeTimer: number | undefined;

    const commitDimensions = () => {
      setHeight(window.innerHeight);
      setHorizontal(isLandscapeShape());
    };

    const handleResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(commitDimensions, 120);
    };

    const handleOrientationChange = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(commitDimensions, 120);
    };

    setHeight(window.innerHeight);
    setHorizontal(isLandscapeShape());

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  return { height, horizontal };
};

export default useScreenOrientation;
